export const tr = {
    'help-title': 'Yardım'
};
